import styled from 'styled-components';

export const ParentContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.3rem;
`;
